import React, {Component} from 'react';

class HazyImageHolder extends Component {
  render() {
    let { imgSrc, variant } = this.props;
    return (
      <div className={`le-hazy-image-holder ${variant?variant:''}`}>
        <img src={imgSrc} alt="grid" className={variant?variant:''} />
      </div>
    );
  }
}

export default HazyImageHolder;